"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _core = require("@material-ui/core");

var _styles = require("@material-ui/core/styles");

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  padding: ", ";\n  background: ", ";\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n        transform: translate(-", "px, -", "px);\n      "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n\n  input {\n    padding-top: 18px;\n    padding-left: ", "px;\n  }\n\n  > div {\n    ", "\n  }\n\n  &:before {\n    border-bottom-color: ", " !important;\n  }\n\n  &:after {\n    border-bottom-color: ", ";\n    transform: ", ";\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  padding-left: ", "px;\n  max-width: ", ";\n  color: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var styles = {
  cssShrink: {
    '&$cssLabel': {
      fontWeight: 600,
      transform: 'translate(0, 13px) scale(0.8)',
      maxWidth: 'initial'
    }
  },
  cssLabel: {}
};
var StyledFormControl = (0, _styledComponents.default)(_core.FormControl)(_templateObject());

var WrapperInput = _styledComponents.default.div(_templateObject2(), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.grey['200'];
});

var StyledInputLabel = (0, _styledComponents.default)(function (_ref2) {
  var hasAdornment = _ref2.hasAdornment,
      props = _objectWithoutProperties(_ref2, ["hasAdornment"]);

  return _react.default.createElement(_core.InputLabel, props);
})(_templateObject3(), function (_ref3) {
  var theme = _ref3.theme;
  return theme.spacing.unit;
}, function (_ref4) {
  var theme = _ref4.theme,
      hasAdornment = _ref4.hasAdornment;
  return hasAdornment ? "calc(100% - ".concat(theme.spacing.unit + 50, "px)") : '100%';
}, function (_ref5) {
  var disabled = _ref5.disabled;
  return !disabled && 'inherit !important';
});

var WrapLabel = _styledComponents.default.span(_templateObject4());

var StyledInput = (0, _styledComponents.default)(_core.Input)(_templateObject5(), function (_ref6) {
  var theme = _ref6.theme;
  return theme.spacing.unit;
}, function (_ref7) {
  var theme = _ref7.theme;
  return (0, _styledComponents.css)(_templateObject6(), theme.spacing.unit, theme.spacing.unit / 2);
}, function (props) {
  return props.theme.palette.grey.A200;
}, function (_ref8) {
  var state = _ref8.state,
      theme = _ref8.theme;
  return state ? theme.palette[state].main : theme.palette.primary.main;
}, function (_ref9) {
  var state = _ref9.state;
  return state && 'scaleX(1)';
});
var StyledFormHelperText = (0, _styledComponents.default)(_core.FormHelperText)(_templateObject7(), function (props) {
  return props.theme.palette.common.black;
}, function (_ref10) {
  var theme = _ref10.theme,
      state = _ref10.state;
  return state && "".concat(theme.spacing.unit / 2, "px ").concat(theme.spacing.unit, "px");
}, function (_ref11) {
  var theme = _ref11.theme,
      state = _ref11.state;
  return state && theme.palette[state].main;
});

var TextField = function TextField(_ref12) {
  var label = _ref12.label,
      placeholder = _ref12.placeholder,
      value = _ref12.value,
      classes = _ref12.classes,
      state = _ref12.state,
      type = _ref12.type,
      onChange = _ref12.onChange,
      endAdornment = _ref12.endAdornment,
      helperText = _ref12.helperText,
      disabled = _ref12.disabled,
      readOnly = _ref12.readOnly,
      focus = _ref12.focus,
      inputProps = _ref12.inputProps,
      props = _objectWithoutProperties(_ref12, ["label", "placeholder", "value", "classes", "state", "type", "onChange", "endAdornment", "helperText", "disabled", "readOnly", "focus", "inputProps"]);

  var IconName = state && (state === 'success' ? 'check_circle_outline' : 'error_outline');
  return _react.default.createElement(StyledFormControl, props, _react.default.createElement(WrapperInput, null, _react.default.createElement(StyledInputLabel, {
    classes: {
      shrink: classes.cssShrink
    },
    FormLabelClasses: {
      root: classes.cssLabel
    },
    hasAdornment: !!endAdornment,
    disabled: disabled
  }, _react.default.createElement(WrapLabel, null, label)), _react.default.createElement(StyledInput, Object.assign({
    autoFocus: focus,
    endAdornment: endAdornment || IconName && _react.default.createElement(_core.InputAdornment, {
      position: "end"
    }, _react.default.createElement(_Icon.default, {
      name: IconName
    }))
  }, {
    type: type,
    placeholder: placeholder,
    state: state,
    value: value,
    onChange: onChange,
    disabled: disabled,
    readOnly: readOnly
  }, inputProps))), helperText && _react.default.createElement(StyledFormHelperText, {
    state: state
  }, helperText));
};

TextField.defaultProps = {
  label: '',
  placeholder: '',
  state: null,
  value: '',
  classes: {},
  type: 'text',
  onChange: null,
  endAdornment: null,
  icon: null,
  helperText: '',
  disabled: false,
  readOnly: false,
  focus: false,
  inputProps: {}
};

var _default = (0, _styles.withStyles)(styles)(TextField);

exports.default = _default;